import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetTaxFormPrefillRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetTaxFormPrefillResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getTaxFormPrefill = (request: GetTaxFormPrefillRequest, options?: CashRequestOptions) =>
  post<GetTaxFormPrefillRequest, GetTaxFormPrefillResponse>('/2.0/cash/get-tax-form-prefill', request, {
    ...options,
    rejectOnError: true,
  })
